















































































import { Component, Inject, Ref, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { date2Num, dateEndofDay, newDate } from '@/data/utils/helper';
import { Accountable, MovementType } from '@/data/models/movimento.model';
import { MovementService } from '@/data/services/movimento.service';

@Component
export default class CassaFilter extends Vue {

	@Inject('MovementService') movementService!: MovementService;

	@Ref('person') person: any;

	advancedSearch: Search;

	searchParam: any = new class {
		createdates?: Date[] = [];
		person?: string = '';
		conto?: string | null = null;
		types?: string[] = [ MovementType.STANDARD ];
	};

	types = Object.keys(MovementType).map(
		// @ts-ignore
		(k: string) => MovementType[k]
	);

	state!: State;

	loadingAccountable: boolean = false;
	itemsAccountable: Accountable[] = [];

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('movement');
	}

	beforeMount() {
		this.advancedSearch.addHeader('progressivenumber', this.$t('progressivo').toString());
		this.advancedSearch.addHeader('year', this.$t('year').toString());
		this.advancedSearch.addHeader('movdate', this.$t('date').toString());
		this.advancedSearch.addHeader('fromaccountdescr', 'Da');
		this.advancedSearch.addHeader('toaccountdescr', 'A');
		this.advancedSearch.addHeader('amount', this.$t('amount').toString());
		this.advancedSearch.addHeader('insdate', this.$t('insdate').toString());
	}

	search() {

		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.createdates && this.searchParam.createdates.length) {
			const start = this.searchParam.createdates[0] ? date2Num(this.searchParam.createdates[0]) : 0;
			const end = this.searchParam.createdates[1] ? date2Num(dateEndofDay(this.searchParam.createdates[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('movdate', start as number, end as number);
		}

		if (this.searchParam.person) {
			this.advancedSearch.addSimpleFilter('fromaccount', this.searchParam.person);
		}

		if (this.searchParam.conto) {
			this.advancedSearch.addSimpleFilter('toaccount', this.searchParam.conto);
		}

		if (this.searchParam.types && this.searchParam.types.length) {
			this.advancedSearch.addInFilter('movtype', this.searchParam.types);
		}

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.createdates = undefined;
		this.searchParam.person = undefined;
		this.searchParam.conto = undefined;
		this.searchParam.types = [MovementType.STANDARD];
		this.person.setSelected({});
		this.search();
	}

	onSelectAccountable(event: Accountable) {
		this.searchParam.person = event ? event.account : undefined;
	}

	onTypingAccountable(term: string) {
		if (term) {
			this.movementService
				.searchAccountable(term)
				.then((result) => {
					this.itemsAccountable = result;
				})
				.finally(() => (this.loadingAccountable = false));
		} else {
			this.itemsAccountable = [];
		}
	}

	advexport() {
		this.$emit('export', this.advancedSearch);
	}

}
